/* eslint-disable */

import { createSelector } from '@reduxjs/toolkit';
import { IApplicationState } from 'shared/types/redux';
import type { ICrossLinks } from '../../containers/SeoCrossLinksContainer/types';

function mapLinks(links: Array<{ name?: string; uri?: string }> | undefined): ICrossLinks['links'] {
  if (!links?.length) return [];
  return links.map(link => ({
    name: link.name ?? '',
    uri: link.uri ?? '',
  }));
}

function toCrossLinkBlock(
  block: { title?: string; links?: Array<{ name?: string; uri?: string }> } | undefined,
): ICrossLinks | null {
  if (!block?.links?.length) return null;
  return {
    title: block.title ?? '',
    links: mapLinks(block.links),
  };
}

/**
 * Возвращает SEO cross-links из ответа API /v2/get-seo-links-search/,
 * преобразованные в формат для компонента SeoCrossLinks.
 * Порядок блоков: flatsInJk, flatsType, затем блоки из nearestGeo.tabs.
 */
export const selectSeoCrossLinks = createSelector(
  (state: IApplicationState) => state.landing.seoCrossLinks?.seoBlocks,
  seoBlocks => {
    if (!seoBlocks) return [];

    const blocks: ICrossLinks[] = [];

    const banks = toCrossLinkBlock(seoBlocks.banks);
    if (banks) blocks.push(banks);

    const programs = toCrossLinkBlock(seoBlocks.programs);
    if (programs) blocks.push(programs);

    const nearestGeo = toCrossLinkBlock(seoBlocks.nearestGeo);
    if (nearestGeo) blocks.push(nearestGeo);

    return blocks;
  },
);
